/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

// Bootstrap fully removed — Tailwind drives the design system now.
// Only domain-specific legacy emotion CSS that is still referenced by un-migrated
// components is loaded below. These do NOT include bootstrap utility classes
// (.btn, .p-*, .shadow-*, .border, .text-*, .row/.col, .form-*) which conflict
// with Tailwind utilities of the same name but different values.

import iconStyles from './_icons.css';
import clockStyles from './_clock.css';
import diagramStyles from './_diagram.css';
import jsonEditorStyles from './_jsoneditor.css';
import blocklyEditorStyles from './_blocklyeditor.css';

const styles = [
  iconStyles,
  clockStyles,
  diagramStyles,
  jsonEditorStyles,
  blocklyEditorStyles,
];

export default $ => {
  return css(styles.map(style => style($)));
};
